import { GetterTree } from "vuex";
import { BrandingState } from "./interfaces";
import { RootState } from "@/store/modules/root/interfaces";
import { GET_BRANDING } from "./constants";

const getters: GetterTree<BrandingState, RootState> = {
  [GET_BRANDING]: (state) => state
};

export default getters;
